import React, { useRef, useState, useEffect } from 'react'

import * as Styled from './styles'

interface Props {
  hideButtons?: boolean
  children: React.ReactNode
}

const ScrollButtons: React.FC<Props> = ({ hideButtons = false, children }) => {
  const ref = useRef<HTMLDivElement>(null)

  const [hasHorizontalScrollBar, setHasHorizontalScrollBar] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [isScrolledToEnd, setIsScrolledToEnd] = useState(false)

  useEffect(() => {
    if (!ref.current) return

    function checkScrollBar(): void {
      setHasHorizontalScrollBar(
        // @ts-expect-error // TODO
        ref.current?.childNodes?.[0].scrollWidth > ref.current?.childNodes[0].getBoundingClientRect().width
      )
    }

    checkScrollBar()

    window.addEventListener('resize', checkScrollBar)

    ref.current.childNodes[0].addEventListener('scroll', () => {
      if (!ref.current) return
      // @ts-expect-error // TODO
      setIsScrolled(ref.current.childNodes[0].scrollLeft > 0)
      setIsScrolledToEnd(
        // @ts-expect-error // TODO
        ref.current.childNodes[0].offsetWidth + ref.current.childNodes[0].scrollLeft >= ref.current.childNodes[0].scrollWidth
      )
    })

    return () => {
      window.removeEventListener('resize', checkScrollBar)
    }
  }, [ref])

  return (
    <Styled.ScrollButtons
      ref={ref}
      // @ts-expect-error // TODO
      hideButtons={hideButtons}
      hasHorizontalScrollBar={hasHorizontalScrollBar}
      isScrolled={isScrolled}
      isScrolledToEnd={isScrolledToEnd}
    >
      {children}
      {!hideButtons && hasHorizontalScrollBar && (
        <>
          {isScrolled && (
            <i
              className="far fa-chevron-left"
              aria-hidden="true"
              onClick={() => {
                // @ts-expect-error // TODO
                ref.current?.childNodes[0].scrollBy({
                  left: -120,
                  behavior: 'smooth',
                })
              }}
            />
          )}
          {!isScrolledToEnd && (
            <i
              className="far fa-chevron-right"
              aria-hidden="true"
              onClick={() => {
                // @ts-expect-error // TODO
                ref.current?.childNodes[0].scrollBy({
                  left: 120,
                  behavior: 'smooth',
                })
              }}
            />
          )}
        </>
      )}
    </Styled.ScrollButtons>
  )
}

export default ScrollButtons
